import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_eorgcmf04w: FaireBrandEntity = {
  token: "b_eorgcmf04w",
  type: "brand",
  name: "Jamboree Jams",
  avatarUrl:
    "https://cdn.faire.com/fastly/3607bcd4f5731e4c7300d0309ac39d1ecde4d885fd3d9d3f32c648f9b9ca3e56.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/1bdaa7853afea54d449c2b5b2fd97ef44217d3c1bd988365df6048276a2d9de3.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/3607bcd4f5731e4c7300d0309ac39d1ecde4d885fd3d9d3f32c648f9b9ca3e56.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/1bdaa7853afea54d449c2b5b2fd97ef44217d3c1bd988365df6048276a2d9de3.jpeg",
  location: "New Orleans, LA, USA",
  minimumOrderDollars: 216,
  rating: 5,
  reviewCount: 3,
  isInsider: true,
  description:
    "We source our fruit from a network of smallhold farmers across the Gulf South. At our New Orleans manufactory, we use traditional methods, seasonal produce, and no added pectin to best express the nature of each fruit. \n",
  meta: {
    source: "api",
    importedAt: "2026-07-09T05:18:07.439Z",
    importedBy: "entity-db-cli",
  },
};
